



















































































































































































































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import { mdbBadge, waves } from '@folky-tools/mdbvue';
import {
    flagsmithService,
    authorizationManagerService,
    businessesService,
    getBusinessPricingMaxLevelService,
    associationsService,
    usersService,
    queryCampaignsService,
    QueryCampaignsOutputDto,
    GetBusinessStatusKpiOutputDto,
    kpisService
} from '@/services';
import { FeatureType } from '@/models/applications/feature-type';
import { Business } from '@/models/businesses/business';
import { Association } from '@/models/associations/association';
import { UserActionLogInfo } from '@/models/users/user-logging/user-action-log-info';
import { UserActionType } from '@/models/users/user-logging/user-action-type';
import { UserActionEntityType } from '@/models/users/user-logging/user-action-entity-type';
import { UserActionScopeType } from '@/models/users/user-logging/user-action-scope-type';

@Component({
    components: {
        mdbContainer: () => import('@folky-tools/mdbvue/src/components/Layout/Container.vue'),
        mdbSideNav: () => import('@folky-tools/mdbvue/src/components/pro/Navigation/SideNav.vue'),
        mdbSideNavNav: () => import('@folky-tools/mdbvue/src/components/pro/Navigation/SideNavNav.vue'),
        mdbSideNavCat: () => import('@folky-tools/mdbvue/src/components/pro/Navigation/SideNavCat.vue'),
        mdbSideNavItem: () => import('@folky-tools/mdbvue/src/components/pro/Navigation/SideNavItem.vue'),
        mdbIcon: () => import('@folky-tools/mdbvue/src/components/Content/Fa.vue'),
        mdbBadge
    }
})
export default class SideNavLoggedIn extends Vue implements waves {
    @Prop() private open: boolean = false;
    @Prop() private readonly unviewedOrders!: number;
    private toggle: boolean = false;
    private showNewAssociationMenu: boolean = false;
    private showAssociationsListMenu: boolean = false;
    private isOwnerOfAnyCampaign: boolean = false;
    private isOwnerOfCampaignIds: number[] = [];
    private showCampaignsMenu: boolean = false;
    private showCampaignReferenceSkuSerialsMenu: boolean = false;
    private showNewBusinessMenu: boolean = false;
    private showBusinessListMenu: boolean = false;
    private showNewReferenceMenu: boolean = false;
    private showNewServiceMenu: boolean = false;
    private showReferencesListMenu: boolean = false;
    private showReferenceDiscountsListMenu: boolean = false;
    private showServicesListMenu: boolean = false;
    private showContactsListMenu: boolean = false;
    private showNewUserInvitationMenu: boolean = false;
    private showUserInvitationsListMenu: boolean = false;
    private showUserActionLogsListMenu: boolean = false;
    private showUserActionBusinessProspectsMenu: boolean = false;
    private showOrdersMenu: boolean = false;
    private showBookingRequestsMenu: boolean = false;
    private showSingleBusinessConfigurationMenu: boolean = false;
    private showSingleAssociationConfigurationMenu: boolean = false;
    private businessProspectsFeatureToggleEnabled: boolean = false;
    private association: Association = new Association();
    private campaignAppList: Array<{ id: number; displayName: string; appUrl: string }> = [];
    private business: Business = new Business();
    private maxBusinessPricingLevel: number | null = 0;
    private businessStatusKpi: GetBusinessStatusKpiOutputDto = new GetBusinessStatusKpiOutputDto();
    private canActualUserAccessDinamizationApp: boolean = false;
    private canActualUserAccessLoyaltyApp: boolean = false;

    private async beforeMount(): Promise<void> {
        this.businessProspectsFeatureToggleEnabled = await flagsmithService.isFeatureEnabled(FeatureType.business_prospects_list);
    }

    private mounted(): void {
        if (authorizationManagerService.permissionsLoaded) {
            this.onUserPermissionsChanged();
        }
    }

    @Watch('open')
    private onOpenChanged(newValue: boolean, oldValue: boolean) {
        this.toggle = newValue;
    }

    @Watch('toggle')
    private onTogleChanged(newValue: boolean, oldValue: boolean) {
        this.$parent.$emit('toggle', newValue);
    }

    private afterEnter(el: any) {
        el.style.maxHeight = '1000px';
    }

    private beforeLeave(el: any) {
        el.style.maxHeight = 0;
    }

    private async onUserPermissionsChanged(): Promise<void> {
        this.canActualUserAccessDinamizationApp = await businessesService.canActualUserAccessDinamizationApp();
        this.canActualUserAccessLoyaltyApp = await businessesService.canActualUserAccessLoyaltyApp();

        this.showNewAssociationMenu = authorizationManagerService.canCreateAssociations;
        this.showAssociationsListMenu = authorizationManagerService.canListAssociations;

        this.isOwnerOfAnyCampaign = authorizationManagerService.isOwnerOfAnyCampaign;
        this.isOwnerOfCampaignIds = authorizationManagerService.isOwnerOfCampaignIds;
        this.showCampaignsMenu = authorizationManagerService.canListCampaigns;
        this.showCampaignReferenceSkuSerialsMenu = authorizationManagerService.canListReferences;

        this.showNewBusinessMenu = authorizationManagerService.canCreateBusiness;
        this.showBusinessListMenu = authorizationManagerService.canListBusiness;

        this.showNewReferenceMenu = authorizationManagerService.canCreateReferences;
        this.showReferencesListMenu = authorizationManagerService.canListReferences;
        this.showReferenceDiscountsListMenu = authorizationManagerService.canCreateReferences;

        this.showNewServiceMenu = authorizationManagerService.canCreateReferences;
        this.showServicesListMenu = authorizationManagerService.canListReferences;

        this.showContactsListMenu = authorizationManagerService.canListBusinessContacts;

        this.showNewUserInvitationMenu = authorizationManagerService.canCreateUserInvitations;
        this.showUserInvitationsListMenu = authorizationManagerService.canListUserInvitations;

        this.showUserActionLogsListMenu = authorizationManagerService.isAdmin;

        this.showUserActionBusinessProspectsMenu = authorizationManagerService.canListBusinessProspects;

        this.showSingleAssociationConfigurationMenu = authorizationManagerService.canWriteOnlySingleAssociation;
        if (this.showSingleAssociationConfigurationMenu) {
            this.association = await associationsService.getAssociation(authorizationManagerService.authorizedAssociationsIdsToEdit[0]);
        }

        if (this.showCampaignsMenu) {
            // Campaigns the user has access to (closed ones excluded server-side), shown as external
            // links to each campaign's CampaignManagement app; only those with a configured URL.
            const campaignsList: QueryCampaignsOutputDto[] = await queryCampaignsService.execute();
            this.campaignAppList = campaignsList.map(campaign => ({ id: campaign.id, displayName: campaign.displayName, appUrl: this.campaignAppUrl(campaign.id) })).filter(campaign => !!campaign.appUrl);
        }

        this.showSingleBusinessConfigurationMenu = authorizationManagerService.canWriteOnlySingleBusiness;
        if (this.showSingleBusinessConfigurationMenu) {
            this.business = await businessesService.getBusiness(authorizationManagerService.authorizedBusinessIdsToEdit[0]);
            this.businessStatusKpi = await kpisService.getBusinessStatusKpi(authorizationManagerService.authorizedBusinessIdsToEdit[0]);
            this.maxBusinessPricingLevel = this.business.pricingLevel;
        } else {
            this.maxBusinessPricingLevel = await getBusinessPricingMaxLevelService.execute();
        }

        this.showOrdersMenu = authorizationManagerService.canListBusinessOrders;

        this.showBookingRequestsMenu = authorizationManagerService.canListBusinessBookingRequests;
    }

    private randomMinMax(min: number, max: number) {
        return Math.floor(Math.random() * (+max - +min) + +min);
    }

    private async onGoToHelpPage(): Promise<void> {
        await usersService.logUserAction(
            new UserActionLogInfo({
                type: UserActionType.HasVisited,
                entity: UserActionEntityType.Users,
                scope: UserActionScopeType.HelpSite
            })
        );
    }

    // Per-campaign CampaignManagement app URL for the current environment (VUE_APP_CAMPAIGN_ID_{id}_URL),
    // pointing at its dashboard.
    private campaignAppUrl(id: number): string {
        const url = process.env[`VUE_APP_CAMPAIGN_ID_${id}_URL`];
        // Carry the current language across (like the other app links) so CampaignManagement keeps eu/es.
        return url ? `${url}/dashboard?ui_locales=${this.$i18n.locale}` : '';
    }

    private get showAccessToDynamizationApp() {
        return process.env.VUE_APP_SHOW_ACCESS_TO_DYNAMIZATION_APP === 'true' && this.canActualUserAccessDinamizationApp;
    }

    public get linkToDynamizationApp() {
        return `${process.env.VUE_APP_DYNAMIZATION_URL}/dashboard?ui_locales=${this.$i18n.locale}`;
    }

    private get showAccessToMessagingApp(): boolean {
        return process.env.VUE_APP_SHOW_ACCESS_TO_MESSAGING_APP === 'true' && authorizationManagerService.isAdmin;
    }

    public get linkToMessagingApp() {
        return `${process.env.VUE_APP_MESSAGING_URL}/dashboard?ui_locales=${this.$i18n.locale}`;
    }

    private get showAccessToLoyaltyApp() {
        return process.env.VUE_APP_SHOW_ACCESS_TO_LOYALTY_APP === 'true' && this.canActualUserAccessLoyaltyApp;
    }

    public get linkToLoyaltyApp() {
        return `${process.env.VUE_APP_LOYALTY_URL}/dashboard?ui_locales=${this.$i18n.locale}`;  
    }
}
